import { CommonModule, DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { OrderCreation, OrderService } from 'com.trumbull.phx.order.api-client';
import { CaseFileItemCreation, CaseFilePartyItemCreation, CaseFilePartyRoleItem, CaseFilePartyRoleItemCreation, PartyCreation, PartyLocatorCreation } from 'com.trumbull.phx.casefile.api-client';
import * as _ from 'lodash';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { StepperModule } from 'primeng/stepper';
import { ToastModule } from 'primeng/toast';
import { OrderInfoComponent } from '../../order-info/order-info.component';
import { AuthorizationComponent } from '../authorization/authorization.component';
import { RecordsComponent } from '../records/records.component';
import { SubjectsComponent } from '../subjects/subjects.component';
import { SubpoenaComponent } from '../subpoena/subpoena.component';
import { Router } from '@angular/router';
import { Step, states, steps, PartyTypeCode, PartyRoleCode, Attachment } from './place-order.model';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { VocabApiService } from '../../vocab/vocab.service';
import { Contact, OrderInfo } from '../../order-info/order-info.model';
import { PartyNameCreation, RecordRetrievalObjectiveItemCreation, RecordRetrievalPartyItemCreation, RecordRetrievalPartyRoleItemCreation, RecordRetrievalRequestItemCreation, RecordRetrievalRequestRecordScopeItemCreation } from 'com.trumbull.phx.recordretrievalobjective.api-client';
import { Authorization, Authorizations } from '../authorization/authorization.model';
import { Subpoena } from '../subpoena/subpoena.model';
import { Subjects } from '../subjects/subjects.model';
import { Records } from '../records/records.model';
import { IPSAuthenticationService } from '@ips/common-angular';

@Component({
  selector: 'app-place-order',
  imports: [StepperModule, ButtonModule, CommonModule, OrderInfoComponent, SubjectsComponent, AuthorizationComponent, SubpoenaComponent, RecordsComponent, ToastModule, CheckboxModule, FormsModule],
  templateUrl: './place-order.component.html',
  styleUrl: './place-order.component.scss',
  providers: [MessageService, DatePipe]
})

export class PlaceOrderComponent implements OnInit{
  constructor(
    private messageService: MessageService,
    private readonly orderService: OrderService,
    private readonly router: Router,
    private readonly vocabService: VocabApiService,
    private readonly authService: IPSAuthenticationService,
    private datePipe: DatePipe) {  }

  @ViewChild(OrderInfoComponent) orderInfoComponent!: OrderInfoComponent;
  @ViewChild(SubjectsComponent) subjectsComponent!: SubjectsComponent;
  @ViewChild(SubpoenaComponent) subpoenaComponent!: SubpoenaComponent;
  @ViewChild(AuthorizationComponent) authorizationComponent!: AuthorizationComponent;
  @ViewChild(RecordsComponent) recordsComponent!: RecordsComponent;

  orderInfoData!: OrderInfo;
  subjectsData!: Subjects;
  subpoenaData: Subpoena | undefined;
  authorizationData: Authorizations | undefined;
  recordsData!: Records;
  activeStep: number = 1;
  activeSteps: Step[] = _.cloneDeep(_.filter(steps, 'visible'));
  isFormValid: boolean = false;
  isFormSubmitted: boolean = false;
  invalidControls: string [] = [];
  states = states;
  organization: any = '';
  
  ngOnInit(): void {
    this.vocabService.getVocabData(['PhysicalLocationUsAddressStateCode']).subscribe(data => {
      // console.log('Vocab Data:', data);
      if (data) {
        const vocabData = data.find(d => d.vocabularyName === 'PhysicalLocationUsAddressStateCode');
        if (vocabData) {
          this.states = vocabData.vocabularyItems.map(item => ({ name: item.description, value: item.code }));
        }
        
      }
    });  

    this.authService.currentUser.forEach(user => {
      let organizationValue = user?.definition?.attributes?.find(item => item?.key === 'organization');
      if(organizationValue?.value)
      {
       this.organization = organizationValue?.value;
      }
    }); 
  }

  CheckIfAttornySelected(): boolean {
    const selectedCategory =  this.orderInfoData?.selectedCategory;
    if((selectedCategory?.name === 'subpoena-to-be-prepared' || selectedCategory?.name === 'authorization-not-provided') && this.orderInfoData.contacts.filter((contact:any) => contact.contactTitle.value === "attorney" ).length <= 0){
      this.messageService.add({ severity: 'error', summary: 'ERROR', detail: 'Please add one contact as attorney to place this order', sticky: true});
      return false;
    }
    return true;
  }

  onPrevious() {
    this.messageService.clear();
    let stepIndex = _.findIndex(this.activeSteps, (item: { value: number; }) => item.value == this.activeStep);
    this.updateFormData(this.activeSteps[stepIndex]);
    this.activeSteps[stepIndex].status = this.activeSteps[stepIndex].status == 'inProgress' ? 'inComplete' : this.activeSteps[stepIndex].status;
    this.activeStep = this.activeSteps[stepIndex - 1].value;
  }

  onNext() {
    let stepIndex = _.findIndex(this.activeSteps, item => item.value == this.activeStep);
    if (this.checkValidity(this.activeSteps[stepIndex])) {
      this.messageService.clear();
      if (this.CheckIfAttornySelected()) {
        this.messageService.clear();
        this.activeSteps[stepIndex].status = 'completed';
        this.activeStep = this.activeSteps[stepIndex + 1].value;
        this.activeSteps[stepIndex + 1].status = 'inProgress'; 
      }
    } 
    else {
      this.messageService.clear();
      const errorMessage = this.invalidControls.length ? `${_.join(this.invalidControls, ', ')} is mandatory. ` : '';
      this.messageService.add({ severity: 'error', summary: 'ERROR', detail: `${errorMessage}Please fill out all the mandatory fields before proceeding`, sticky: true });
    }
    this.orderInfoComponent.validate();
  }

  onFinish() {
    this.isFormSubmitted = true;
    let stepIndex = _.findIndex(this.activeSteps, item => item.value == this.activeStep);
    if (this.checkValidity(this.activeSteps[stepIndex])) {
      this.messageService.clear();
      const requestPayload = this.getSubmitOrderPayload();
      console.log(requestPayload);
      this.orderService.createOrder('standard', requestPayload as OrderCreation).subscribe({
        next: (res) => {
          this.router.navigate(['/home/order-success'], { state: { orderNumber: res?.orderNumber, orderedDate: res?.orderedDate, incidentDate: this.orderInfoData?.orderInfoDate, claimNumber: this.orderInfoData?.orderInfoRefNum } });
        },
        error: (error) => {
          this.isFormSubmitted = false;
        },
        complete: () => {
          this.isFormSubmitted = false;
        }
      });
      // this.router.navigate(['/home/order-success'],{ state: { orderNumber: '123', orderedDate: '2025-03-12T08:43:57.307-04:00', incidentDate: this.orderInfoData?.orderInfoDate}});
    }    
    else {
      this.isFormSubmitted = false;
      this.messageService.clear();
      const errorMessage = this.invalidControls.length ? `${_.join(this.invalidControls, ', ')} is mandatory. ` : '';
      this.messageService.add({ severity: 'error', summary: 'ERROR', detail: `${errorMessage}Please fill out all the mandatory fields before proceeding`, sticky: true });
    }
  }

  getInvalidControls(form: any, formArray:boolean = false) {
    if(!formArray)
      this.invalidControls = [];
    Object.keys(form.controls).forEach(controlName => {
      var control = form.get(controlName);
      if(control && _.get(control, 'controls')) {
        this.getInvalidControls(control, true);
      } else if (control && control.invalid) {
        this.invalidControls.push(control?.displayName ? control?.displayName : controlName);  // Collect invalid control names
      }
    });
  }

  setCurrentStep(step: Step) {
    this.messageService.clear();
    let stepIndex = _.findIndex(this.activeSteps, item => item.value == this.activeStep);
    this.updateFormData(this.activeSteps[stepIndex]);
    // if (this.checkValidity(this.activeSteps[stepIndex])) {
      this.activeSteps[stepIndex].status = this.activeSteps[stepIndex].status == 'inProgress' ? 'inComplete' : this.activeSteps[stepIndex].status;
      this.activeStep = step.value;
    // }
  }

  isLastStep() {
    return this.activeStep === this.activeSteps[this.activeSteps.length - 1]?.value
  }

  updateStepper(orderType: any) {

    switch(orderType) {
      case 'subpoena-to-be-prepared':
        let stepIndex = _.findIndex(this.activeSteps, ['label', 'Subpoena']);
        let subpoenaStep = _.cloneDeep(_.find(steps, ['label', 'Subpoena']));
        if (stepIndex == -1 && subpoenaStep) {
          subpoenaStep.visible = true;
          this.activeSteps.splice(2, 0, subpoenaStep);
        }
  
        _.remove(this.activeSteps, ['label', 'Authorization']);
      break;
      case 'authorization-not-provided':
        let stepIndex2 = _.findIndex(this.activeSteps, ['label', 'Authorization']);
        let authorizationStep = _.cloneDeep(_.find(steps, ['label', 'Authorization']));
        if (stepIndex2 == -1 && authorizationStep) {
          authorizationStep.visible = true;
          this.activeSteps.splice(2, 0, authorizationStep);
        }
        _.remove(this.activeSteps, ['label', 'Subpoena']);
      break;
      default:
        _.remove(this.activeSteps, ['label', 'Subpoena']);
        _.remove(this.activeSteps, ['label', 'Authorization']);

    }
  }

  checkValidity(step: Step) {
    switch (step.label) {
      case 'Order Info':
        this.orderInfoData = this.orderInfoComponent.formGroup.getRawValue();
        if (!this.orderInfoComponent.formGroup.valid) {
          this.orderInfoComponent.formGroup.markAllAsTouched();
          this.getInvalidControls(this.orderInfoComponent.formGroup);
        }
        // return true;
        return this.orderInfoComponent.formGroup.valid;
        break;
      case 'Subjects':
        this.subjectsData = this.subjectsComponent.formGroup.value;
        if (!this.subjectsComponent.formGroup.valid) {
          this.subjectsComponent.formGroup.markAllAsTouched();
          this.subjectsComponent.formGroup.updateValueAndValidity();
          this.getInvalidControls(this.subjectsComponent.formGroup);
        }
        // return true;
        return this.subjectsComponent.formGroup.valid;
        break;
      case 'Subpoena':
        this.subpoenaData = this.subpoenaComponent.formGroup.value;
        if (!this.subpoenaComponent.formGroup.valid) {
          this.subpoenaComponent.formGroup.markAllAsTouched();
          this.getInvalidControls(this.subpoenaComponent.formGroup);
        }
        // return true;
        return this.subpoenaComponent.formGroup.valid;
        break;
      case 'Authorization':
        this.authorizationData = this.authorizationComponent.formGroup.value;
        if (!this.authorizationComponent.formGroup.valid) {
          this.authorizationComponent.formGroup.markAllAsTouched();
          this.getInvalidControls(this.authorizationComponent.formGroup);
        }
        // return true;
        return this.authorizationComponent.formGroup.valid;
        break;
      case 'Records':
        this.recordsData = this.recordsComponent.recordsFormGroup.value;
        if (!this.recordsComponent.recordsFormGroup.valid) {
          this.recordsComponent.recordsFormGroup.markAllAsTouched();
          this.getInvalidControls(this.recordsComponent.recordsFormGroup);
        }
        return this.recordsComponent.recordsFormGroup.valid;
      default:
        return true;
    }
  }


  updateFormData(step: Step) {
    switch (step.label) {
      case 'Order Info':
        this.orderInfoData = this.orderInfoComponent.formGroup.getRawValue();
        break;
      case 'Subjects':
        this.subjectsData = this.subjectsComponent.formGroup.value;
        break;
      case 'Subpoena':
        this.subpoenaData = this.subpoenaComponent.formGroup.value;
        break;
      case 'Authorization':
        this.authorizationData = this.authorizationComponent.formGroup.value;
        break;
      case 'Records':
        this.recordsData = this.recordsComponent.recordsFormGroup.value;
    }
  }

  onFormChange() {
    let currentStep = _.find(this.activeSteps, ['value', this.activeStep]);
    if(currentStep && currentStep.status == 'completed') {
      currentStep.status = 'inProgress';
      _.forEach(this.activeSteps, (step) => {
        if(currentStep && step.value > currentStep.value) {
          step.status = 'none';
        }
      });
    }
  }

  getFormatedDate(date: any) {
    let formattedDate: string = '';
    if(date) {
      formattedDate = this.datePipe.transform(date, 'yyyy-MM-ddTHH:mm:ss.sss')??'';
      formattedDate = formattedDate + 'Z';
    }

    return formattedDate;
    
  }

  getSubmitOrderPayload(){
    
    let result:OrderCreation; 

    let caseObject: CaseFileItemCreation = {
      typeCode: 'civil',
      referenceNumber: this.orderInfoData?.orderInfoRefNum,
      incidentDate: this.getFormatedDate(this.orderInfoData?.orderInfoDate),
      firmCode: this.organization,
      parties: this.getCaseParties()
    } as CaseFileItemCreation;

    let retrievalObjective: RecordRetrievalObjectiveItemCreation = {
      orderTypeCode: this.orderInfoData?.selectedCategory?.name,
      serviceLevelCode: this.orderInfoData?.selectedLevel ? 'Rush' : 'Normal',
      specialInstructions: this.orderInfoData?.orderInfoSpecialInstructions,
      parties: this.getRetrievalObjectiveParties()
    } as RecordRetrievalObjectiveItemCreation;

    retrievalObjective.requests = this.getRetrievalObjectiveRequest(retrievalObjective.parties);

    result = {
      typeCode: 'record-retrieval',
      customerReferenceNumber: this.orderInfoData?.orderInfoRefNum,
      summaryDescription: this.orderInfoData?.orderInfoRefNum +':' +this.orderInfoData?.selectedCategory?.name,
      qualifiers: {},
      data: {
        case: caseObject,
        retrievalObjective: retrievalObjective,
        attachments: this.getAttachments()
      } 
    }

    return result;
  }

  getAttachments() {
    let attachments: Attachment[] = [];
    _.forEach(this.orderInfoData.orderInfoAttachmentFile, item => {
      let file: Attachment= {
        attachTo: 'retrievalObjective',
        tagNames: [item?.label],
        document: {
          contentType: item?.type,
          description: item?.description,
          fileName: item?.filename,
          displayName: item?.filename,
          sizeBytes:item?.size,
          sizeText:item?.sizeText,
          storageId:item?.storageId,
          storageProviderId:item?.storageProviderId,         
        }
      };
      attachments.push(file);
    });

    return attachments;
  }


  getRetrievalObjectivePartyByTypeCode(code:PartyTypeCode, displayName: any, alias?: any){
    let party: RecordRetrievalPartyItemCreation = {};
    switch (code) {
      case PartyTypeCode.Person:
        let contactName = this.getNames(displayName);
        party.party = {
          typeCode: 'Person',
          displayName: displayName,
          names: [
            {
              function: "first-name",
              text: contactName[0]
            },
            {
              function: "last-name",
              text: (contactName[1] && contactName[1].length > 0) ? contactName[1] : ' '
            }
          ],
          locators: [],
        }

        if(alias) {
          party.party?.names?.push({
            function: 'alias',
            text: alias
          })
        }
        break;
      case PartyTypeCode.Organization:
        party.party = {
          typeCode: 'Organization',
          displayName: displayName,
          names: [
            {
              function: "business-name",
              text: displayName
            }
          ],
          locators: [],
        }
        break;
    }
    return party;
  }

  getCasePartyByTypeCode(code:PartyTypeCode, displayName: any, data?: any){
    let party: CaseFilePartyItemCreation = {};
    switch (code) {
      case PartyTypeCode.Person:
        let contactName = this.getNames(displayName);
        party.party = {
          typeCode: 'Person',
          displayName: displayName,
          names: [
            {
              function: "first-name",
              text: contactName[0]
            },
            {
              function: "last-name",
              text: (contactName[1] && contactName[1].length > 0) ? contactName[1] : ' '
            }
          ],
          locators: [],
        }

        if(data) {
          party.party?.names?.push({
            function: 'title',
            text: data
          })
        }
        break;
      case PartyTypeCode.Organization:
        party.party = {
          typeCode: 'Organization',
          displayName: displayName,
          names: [
            {
              function: "business-name",
              text: displayName
            }
          ],
          locators: [],
        }
        if(data) {
          party.party?.names?.push({
            function: 'contact-name',
            text: data
          })
        }
        break;
    }
    return party;
  }

  getRetrievalObjectiveRequest(parties?: RecordRetrievalPartyItemCreation[]) {
    let requests: RecordRetrievalRequestItemCreation[] = [];
    _.forEach(this.recordsData.records, (item, index) => {
      
      let request: RecordRetrievalRequestItemCreation = {};
      let updatedSSN: string = '';
      let ssnLocator: PartyLocatorCreation = {};
      request.requestNumber = _.toString(index+1);
      request.notes = item.notesTextarea;
      request.subpoenaLanguage = item.subpoenaLanguageTextarea;
      request.scope = [];
      _.forEach(item.selectedTypes, type => {
        let scope:RecordRetrievalRequestRecordScopeItemCreation;
        scope = {
          recordTypeCode: type,
          beginDate: this.getFormatedDate(item.dateToServiceFrom)?? '',
          endDate: this.getFormatedDate(item.dateToServiceTo)?? ''
        }
        switch (type) {
          case 'diagnostic-images':
            scope.qualifiers = {
              diagnosticTypeCodes: item.diagnosticImages?.typesOfImaging ? _.join(_.map(item.diagnosticImages?.typesOfImaging, 'name'), ", ") : '',
              diagnosticFocusArea: item.diagnosticImages?.specificBodyPart,
              diagnosticComments: item.diagnosticImages?.other 
            }
          break;
          case 'ambulance':
            scope.qualifiers = {
              ambulanceDateOfService: item.ambulance?.date,
              ambulanceTimeOfService: item.ambulance?.time,
              ambulancePickupLine1: item.ambulance?.pickupAddress,
              ambulancePickupCity: item.ambulance?.pickupCity,
              ambulancePickupState: item.ambulance?.pickupState?.value,
              ambulancePickupPostal: item.ambulance?.pickupZip,
              ambulanceDropOffLine1: item.ambulance?.dropAddress,
              ambulanceDropOffCity: item.ambulance?.dropCity,
              ambulanceDropOffState: item.ambulance?.dropState?.value,
              ambulanceDropOffPostal: item.ambulance?.dropZip,
            }
          break;
          case 'insurance':
            scope.qualifiers = {
              insuranceClaimNumber: item.insurance?.claimNumber,
              insurancePolicyNumber: item.insurance?.policyNumber
            }
          break;
          case 'military':
            scope.qualifiers = {
              militaryBranch: item.military?.branch,
              militaryServiceNumber: item.military?.serviceNumber
            }
          break;
          case 'union':
            scope.qualifiers = {
              unionMembershipNumber: item.union?.membershipNumber
            }
          break;
          case 'va':
            scope.qualifiers = {
              vaMedicalRecords: item.va?.medical,
              vaBenefitRecords: item.va?.benefit
            }
          break;
          case 'other':
            scope.qualifiers = {
              otherDescriptionOfRecords: item.other?.descriptionOfRecords
            }
          break;
          case 'employment':
            updatedSSN = item.employment?.employmentSS;
          break
          case 'irs':
            updatedSSN = item.irs?.irsSS;
          break
          case 'social-security':
            updatedSSN = item.socialSecurity?.socialSecuritySS;
            ssnLocator = this.getLocationLocator(item.socialSecurity?.address,item.socialSecurity?.city, item.socialSecurity?.state?.value, item.socialSecurity?.zip);
          break;
        }
        
        request.scope?.push(scope);
      });
      requests.push(request);

      //update Parties for requests
      let custodianParty = _.find(parties, (party: RecordRetrievalPartyItemCreation) => {
        return party.party?.displayName == item.providerName && _.some(party.roles,['roleCode', PartyRoleCode.RecordsCustodian]);
      });

      if(custodianParty) {
        let role = _.find(custodianParty.roles,['roleCode', PartyRoleCode.RecordsCustodian]);
        if(role && role?.requestNumbers) {
          role?.requestNumbers?.push(request.requestNumber);
        } else if (role){
          role.requestNumbers = [request.requestNumber];
        }
      }

      //medical Parties for requests
      let medicalProviderParty = _.find(parties, (party: RecordRetrievalPartyItemCreation) => {
        return party.party?.displayName == item.doctor && _.some(party.roles,['roleCode', PartyRoleCode.MedicalProvider]);
      });

      if(medicalProviderParty) {
        let role = _.find(medicalProviderParty.roles,['roleCode', PartyRoleCode.MedicalProvider]);
        if(role && role?.requestNumbers) {
          role?.requestNumbers?.push(request.requestNumber);
        } else if (role){
          role.requestNumbers = [request.requestNumber];
        }
      }

      //record subject parties for requests
      let recordSubjectParty = _.find(parties, (party: RecordRetrievalPartyItemCreation) => {
        return party.party?.displayName == item.subject && _.some(party.roles,['roleCode', PartyRoleCode.RecordSubject]);
      });

      if(recordSubjectParty) {
        let role = _.find(recordSubjectParty.roles,['roleCode', PartyRoleCode.RecordSubject]);
        if(role && role?.requestNumbers) {
          role?.requestNumbers?.push(request.requestNumber);
        } else if (role){
          role.requestNumbers = [request.requestNumber];
        }

        if(updatedSSN && updatedSSN.length > 0 && role?.recordSubject) {
          role.recordSubject.socialSecurityNumber = updatedSSN
        }
        if(ssnLocator?.typeCode) {
          recordSubjectParty.party?.locators?.push(ssnLocator);
        }
      }


    });

    return requests;
  }

  getRetrievalObjectiveParties() {
    let parties: RecordRetrievalPartyItemCreation[] = [];

    //bill-to
    let billParty = this.getRetrievalObjectivePartyByTypeCode(PartyTypeCode.Person, this.orderInfoData.orderInfoBillingContactName);
    billParty?.party?.locators?.push(this.getEmailLocator(this.orderInfoData.orderInfoBillToEmail));

    billParty.roles = [];
    billParty?.roles?.push(this.getRole(PartyRoleCode.BillTo));
    parties.push(billParty);

    //deliver-to
    if (this.orderInfoData.orderInfoAttentionToFirmName) {
      let deliverToParty = this.getRetrievalObjectivePartyByTypeCode(PartyTypeCode.Organization, this.orderInfoData.orderInfoAttentionToFirmName);
      deliverToParty.party?.names?.push({ function: 'contact-name', text: this.orderInfoData.orderInfoAttentionTo });
      deliverToParty?.party?.locators?.push(this.getEmailLocator(this.orderInfoData.orderInfoBillToEmail));
      deliverToParty?.party?.locators?.push(this.getPhoneLocator(this.orderInfoData.orderInfoAttentionToFirmPhone, this.orderInfoData.orderInfoAttentionToFirmPhoneExtn));
      deliverToParty?.party?.locators?.push(this.getLocationLocator(this.orderInfoData.orderInfoAttentionToFirmAddress, this.orderInfoData.orderInfoAttentionToFirmCity, this.orderInfoData.orderInfoAttentionToFirmState?.value, this.orderInfoData.orderInfoAttentionToFirmZip));

      deliverToParty.roles = [];
      deliverToParty?.roles?.push(this.getRole(PartyRoleCode.DeliverTo));
      parties.push(deliverToParty);

    }
    

    //subjects
    _.forEach(this.subjectsData.subjects, item => {
      let subjectParty = this.getRetrievalObjectivePartyByTypeCode(PartyTypeCode.Person, item.recordSubjectName, item.alias);
      if(subjectParty?.party) {
        subjectParty.party.person = {
          dateOfBirth: _.toString(this.datePipe.transform(item.dateOfBirth, 'yyyy-MM-dd')),
          dateOfDeath: _.toString(this.datePipe.transform(item.dateOfDeath, 'yyyy-MM-dd'))
        }
      }
      
      subjectParty.roles = [];
      let tempRole = this.getRole(PartyRoleCode.RecordSubject) as RecordRetrievalPartyRoleItemCreation;
      tempRole.recordSubject = {
        socialSecurityNumber: _.toString(item.ssn)
      }
      subjectParty?.roles?.push(tempRole);
      parties.push(subjectParty);
    });


    //records
    let recordParties: RecordRetrievalPartyItemCreation[] = [];
    _.forEach(this.recordsData.records, item => {
      let providerExists =  _.some(recordParties, recordParty => {
        return recordParty.party?.displayName == item.providerName
      });

      if(!providerExists) {
        let recordsCustodianParty = this.getRetrievalObjectivePartyByTypeCode(PartyTypeCode.Organization, item.providerName);

        recordsCustodianParty.party?.locators?.push(this.getEmailLocator(item.email));
        recordsCustodianParty.party?.locators?.push(this.getLocationLocator(item.streetAddress, item.cityName, item.stateName.value, item.zipCode));
  
        recordsCustodianParty.roles = [];
        recordsCustodianParty.roles?.push(this.getRole(PartyRoleCode.RecordsCustodian));
        recordParties.push(recordsCustodianParty);
      }
      
      if(item.doctor && item.doctor.length > 0) {
        let medicalProviderParty = this.getRetrievalObjectivePartyByTypeCode(PartyTypeCode.Person, item.doctor);
        medicalProviderParty.party?.names?.push({ function: 'title', text: 'Dr.  ' });
        medicalProviderParty.roles = [];
        medicalProviderParty.roles?.push(this.getRole(PartyRoleCode.MedicalProvider));
        recordParties.push(medicalProviderParty);
      }
    });


    return _.concat(parties,recordParties);

  }

  

  getCaseParties() {
    let parties: CaseFilePartyItemCreation[] = [];

    //contact parties
    _.forEach(this.orderInfoData?.contacts, item => {
      let party: CaseFilePartyItemCreation = this.getCasePartyByTypeCode(PartyTypeCode.Person,item.contactName, item.contactTitle.value);

      party?.party?.locators?.push(this.getEmailLocator(item.contactEmail));
      party?.party?.locators?.push(this.getPhoneLocator(item.contactPhone, item.contactPhoneExtn));
      // party.roles = this.getRoles(item);
      party.roles = [];
      party.roles.push(this.getRole(item.contactTitle.value as PartyRoleCode,item.contactBarNo));

      parties.push(party);
    })

    // authorization parties
    if(this.authorizationData) {
      _.forEach(this.authorizationData?.authorizations, item => {
        let party: CaseFilePartyItemCreation = this.getCasePartyByTypeCode(PartyTypeCode.Organization,item.opposingCounselFirmName,item.opposingCounselAttorneyName);

        party?.party?.locators?.push(this.getEmailLocator(item.email));
        party.party?.locators?.push(this.getPhoneLocator(item.phone, item.extn));
        party.party?.locators?.push(this.getFaxLocator(item.fax));
        party.party?.locators?.push(this.getLocationLocator(item.streetAddress,item.city, item.state?.value, item.zip));

        party.roles = [];
        _.forEach(item.recordSubjectName, subject =>{
          party?.roles?.push(this.getRole(PartyRoleCode.PlaintiffAttorney,subject.value));
        });
        parties.push(party);
      })
    }

    // subpoena parties
    if(this.subpoenaData) {
      _.forEach(this.subpoenaData?.opposingCounseals, item => {
        let party: CaseFilePartyItemCreation = this.getCasePartyByTypeCode(PartyTypeCode.Organization,item.opposingCounselFirmName,item.opposingCounselAttorneyName);

        party.party?.locators?.push(this.getEmailLocator(item.email));
        party.party?.locators?.push(this.getPhoneLocator(item.phone, item.extn));
        party.party?.locators?.push(this.getFaxLocator(item.fax));
        party.party?.locators?.push(this.getLocationLocator(item.streetAddress,item.city, item.state?.value, item.zip));

        party.roles = [];
        _.forEach(item.recordSubjectName, subject =>{
          party?.roles?.push(this.getRole(PartyRoleCode.PlaintiffAttorney, subject.value));
        });
        parties.push(party);
      });

      //subpoena defendants
      _.forEach(this.subpoenaData?.defendants, item => {
        let party: CaseFilePartyItemCreation = this.getCasePartyByTypeCode(PartyTypeCode.Person, item.name);
        let contactName = this.getNames(item.name)

        party.party?.locators?.push(this.getLocationLocator(item.streetAddress,item.city, item.state?.value, item.zip));

        party.roles = [];
        party?.roles?.push(this.getRole(PartyRoleCode.Defendant));
        parties.push(party);
      });


      //judge

      let party: CaseFilePartyItemCreation = this.getCasePartyByTypeCode(PartyTypeCode.Organization, this.subpoenaData.jurisdictionCounty);

      party.party?.locators?.push(this.getLocationLocator(this.subpoenaData.courtStreetAddress,this.subpoenaData.cityName, this.subpoenaData.state?.value, this.subpoenaData.zipCode));

      party.roles = [];
      party?.roles?.push(this.getRole(PartyRoleCode.Court, {item1: this.subpoenaData.judge, item2: this.subpoenaData.jurisdictionCounty}));
      parties.push(party);
    }

    return parties;
  }

  getRole(code: PartyRoleCode, data?: any) {
    let roleItem: CaseFilePartyRoleItemCreation = {
      delete: false
    };
    switch (code) {
      case PartyRoleCode.Paralegal:
        roleItem.roleCode = 'defendant-paralegal';
        break;
      case PartyRoleCode.Other:
        roleItem.roleCode = 'contact-other';
        break;
      case PartyRoleCode.Attorney:
        roleItem.roleCode = 'defendant-attorney';
        roleItem.attorney = {
          barNumber: data
        };
        break;
      case PartyRoleCode.PlaintiffAttorney:
        roleItem.roleCode = code;
        roleItem.attorney = {
          representing: data
        };
        break;
      case PartyRoleCode.Defendant:
        roleItem.roleCode = code;
        break;
      case PartyRoleCode.BillTo:
        roleItem.roleCode = code;
        break;
      case PartyRoleCode.DeliverTo:
        roleItem.roleCode = code;
        break;
      case PartyRoleCode.RecordSubject:
        roleItem.roleCode = code;
        break;
      case PartyRoleCode.Court:
        roleItem.roleCode = code;
        roleItem.court = {
          judgeName: data?.item1,
          jurisdiction: data?.item2
        };
        break;
      case PartyRoleCode.RecordsCustodian:
      roleItem.roleCode = code;
      break;
      case PartyRoleCode.MedicalProvider:
      roleItem.roleCode = code;
      break;
      case PartyRoleCode.AmbulanceService:
      roleItem.roleCode = code;
      break;
    }
    return roleItem;
  }

  getEmailLocator(email: any) {
    return {
      typeCode: "email",
      email: {
        purpose: "work",
        address: email
      }
    }
  }

  getFaxLocator(fax: any) {
    return {
      typeCode: "phone",
      phone: {
        purpose: "fax",
        number: fax
      }
    }
  }

  getLocationLocator(lineOne: any, city: any, stateCode: any, postalCode: any) {
    let locationLocator: PartyLocatorCreation ={};

    locationLocator = {
      typeCode: "location",
      location: {
        purpose: "mailing",
        location: {
          typeCode: "us",
          usAddress: {
              lineOne: lineOne,
              city: city,
              stateCode: stateCode,
              postalCode: postalCode
          }
      }
      }
    }

    return locationLocator;
  }

  getPhoneLocator(phone: any, extn: any) {
    let locatorItem: PartyLocatorCreation = {};
    // if (_.toString(phone)?.length > 0) {
      locatorItem = {
        typeCode: "phone",
        phone: {
          purpose: "work",
          number: _.toString(phone)
        }
      }

      if (extn) {
        locatorItem!.phone!.extension = extn
      }
    // }
    return locatorItem;
  }


  getNames(input:any) {
    let result = _.split(input, ' ');

    let firstPart = result[0];
    let secondPart = result.length > 1 ? result.slice(1).join(' ') : '';

    return [firstPart, secondPart];
  }

}
